import { render } from "./SpreadsheetComponent.vue?vue&type=template&id=12c6a44a&scoped=true"
import script from "./SpreadsheetComponent.vue?vue&type=script&lang=js"
export * from "./SpreadsheetComponent.vue?vue&type=script&lang=js"

import "./SpreadsheetComponent.vue?vue&type=style&index=0&id=12c6a44a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c6a44a"]])

export default __exports__